// extracted by mini-css-extract-plugin
module.exports = {"container":"DrawerSearchIcon_container__CWMPY"};